import { put, takeEvery } from 'redux-saga/effects';
import actions from '../actions';

const completeTourSaga = takeEvery(actions.completeTour.request.type, function* (
  action: ReturnType<typeof actions.completeTour.request>
) {
  yield put(actions.completeTour.success(action.payload));
});

const sagas = [completeTourSaga];

export default sagas;
